"use client";
import React from "react";
import SectionHeading from "../shared/SectionHeading";
import TalkToExpert from "../../assets/course-details/other/TalkToExpert.svg";
import personoutline from "../../assets/course-details/other/mdi_person-outline.svg";
import calloutline from "../../assets/course-details/other/ion_call-outline.svg";
import Mail from "../../assets/course-details/other/Mail.svg";
import India from "../../assets/course-details/other/India.svg";
import Dropdown from "../../assets/course-details/other/Dropdown.svg";

const TalkToAnExpert = () => {
  return (
<div className="max-w-[1200px] mx-auto px-4 py-16">
  <SectionHeading>
    <span className="text-primary-color">Talk To</span>{" "}
    <span className="text-secondary-color">An Expert</span>
  </SectionHeading>

  <div className="flex flex-col md:flex-row items-center justify-between gap-10 mt-12">
    {/* Image Section - Left on desktop */}
    <div className="w-full md:w-1/2">
      <img
        className="w-full h-auto object-contain"
        src={TalkToExpert}
        alt="Talk To Expert"
      />
    </div>

    {/* Form Section - Right on desktop */}
    <div className="w-full md:w-1/2 ">
      <h3 className="text-2xl font-semibold text-gray-800 mb-6 text-center md:text-left">
        Add your details to get a call back
      </h3>

      <form className="space-y-5">
        {/* Name Input */}
        <div className="flex items-center gap-3 border border-gray-300 rounded-md p-3 shadow-sm">
          <img src={personoutline} alt="Name" className="w-6 h-6" />
          <input
            type="text"
            id="name"
            placeholder="Eg: Aakash Mehra"
            className="w-full outline-none text-base text-gray-700"
          />
        </div>

        {/* Phone Input */}
        <div className="flex items-center gap-3 border border-gray-300 rounded-md p-3 shadow-sm">
          <img src={calloutline} alt="Phone" className="w-6 h-6" />
          <img src={India} alt="India" className="w-6 h-6" />
          <span className="text-sm font-medium">+91</span>
          <img src={Dropdown} alt="Dropdown" className="w-5 h-5 ml-2" />
          <div className="h-6 w-px bg-gray-300 mx-3" />
          <input
            type="tel"
            id="phonenumber"
            placeholder="Eg: 9025641234"
            className="w-full outline-none text-base text-gray-700"
          />
        </div>

        {/* Email Input */}
        <div className="flex items-center gap-3 border border-gray-300 rounded-md p-3 shadow-sm">
          <img src={Mail} alt="Mail" className="w-6 h-6" />
          <input
            type="email"
            id="email"
            placeholder="Eg: aakashmehra37@hotmail.com"
            className="w-full outline-none text-base text-gray-700"
          />
        </div>

        {/* Submit Button */}
        <div className="text-center md:text-left pt-4">
          <button
            type="submit"
            className="bg-primary-color text-white font-semibold px-6 py-3 rounded-md hover:bg-opacity-90 transition"
          >
            Request a Call Back
          </button>
        </div>
      </form>
    </div>
  </div>
</div>


  );
};

export default TalkToAnExpert;
